import { render, staticRenderFns } from "./Will.vue?vue&type=template&id=47c4ed74&scoped=true&"
import script from "./Will.vue?vue&type=script&lang=js&"
export * from "./Will.vue?vue&type=script&lang=js&"
import style0 from "./Will.vue?vue&type=style&index=0&id=47c4ed74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c4ed74",
  null
  
)

export default component.exports